// Game modes (the fantasy you play). Only 'director' — build and run your
// club — is playable today; the rest are roadmap and shown as "coming soon"
// so the menu communicates the vision without promising what isn't built.

import { Briefcase, Activity, ClipboardList, Globe, type LucideIcon } from 'lucide-react'

export type GameMode = 'director' | 'player' | 'coach' | 'multiplayer'

export interface GameModeDef {
  id: GameMode
  label: string
  tagline: string
  icon: LucideIcon
  available: boolean
}

export const GAME_MODES: GameModeDef[] = [
  {
    id: 'director',
    label: 'Carrera del Director',
    tagline: 'Construye y dirige tu club: terreno, pistas, plantilla, liga y junta directiva.',
    icon: Briefcase,
    available: true,
  },
  {
    id: 'player',
    label: 'Jugador Profesional',
    tagline: 'Vive la carrera de un jugador: ranking, partidos y patrocinios.',
    icon: Activity,
    available: false,
  },
  {
    id: 'coach',
    label: 'Entrenador Profesional',
    tagline: 'Te hacen cargo de un club ya montado: céntrate en la plantilla, el entrenamiento y los resultados.',
    icon: ClipboardList,
    available: true,
  },
  {
    id: 'multiplayer',
    label: 'Multijugador',
    tagline: 'Compite online contra otros clubes en ligas y torneos.',
    icon: Globe,
    available: false,
  },
]

export const DEFAULT_GAME_MODE: GameMode = 'director'

// In Coach mode you don't build or run the club's facilities/economy, so those
// destinations are hidden from navigation (the club is pre-built and solvent).
export const COACH_HIDDEN_ROUTES = new Set<string>(['/club', '/facilities', '/services'])
